import React from 'react';
import { heroData } from '../data/mock';
import { ArrowRight } from 'lucide-react';
import useScrollAnimation from '../hooks/useScrollAnimation';
import HeroVisuals from './graphics/HeroVisuals';
import HeroInteractiveVisual from './graphics/HeroInteractiveVisual';

const CALENDLY_LINK = 'https://calendly.com/shantanu-leadership-coaching/1-1-coffee-chat?month=2026-03';

export const HeroSection = () => {
  const [headlineRef, headlineVisible] = useScrollAnimation({ threshold: 0.2 });
  const [ctaRef, ctaVisible] = useScrollAnimation({ threshold: 0.2 });

  return (
    <section className="min-h-screen flex items-center bg-[#fffef2] pt-20 relative overflow-hidden">
      {/* Interactive Canvas Visual */}
      <HeroInteractiveVisual />
      
      {/* Static Animated Visual Elements (backup/overlay) */}
      <HeroVisuals />

      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 lg:py-32 relative z-10">
        <div className="max-w-2xl">
          {/* Main Headline */}
          <div 
            ref={headlineRef}
            className={`animate-on-scroll ${headlineVisible ? 'is-visible' : ''}`}
          >
            <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl text-[#333333] leading-tight mb-4">
              {heroData.headline}
            </h1>
            <p className="font-serif text-2xl md:text-3xl lg:text-4xl text-[#333333] leading-tight mb-12">
              {heroData.headlineContinued}
            </p>
          </div>

          {/* Subheading */}
          <div
            ref={ctaRef}
            className={`animate-on-scroll ${ctaVisible ? 'is-visible' : ''}`}
            style={{ transitionDelay: '0.2s' }}
          >
            <p className="text-base md:text-lg text-[#666666] leading-relaxed max-w-xl mb-8">
              {heroData.subheading}
            </p>

            {/* Selectivity Note */}
            <p className="text-sm text-[#4a4a4a] italic mb-12">
              {heroData.selectivityNote}
            </p>

            {/* CTA Group */}
            <div className="flex flex-col sm:flex-row items-start gap-6">
              <a
                href={CALENDLY_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative inline-flex items-center justify-center gap-3 px-8 py-5 text-sm font-medium text-[#333333] border border-[#333333] overflow-hidden transition-all duration-500 hover:text-[#fffef2] hover:border-[#5a7fa8]"
              >
                {/* Animated background */}
                <span className="absolute inset-0 bg-gradient-to-r from-[#333333] via-[#5a7fa8] to-[#333333] transform -translate-x-full group-hover:translate-x-0 transition-transform duration-700" />
                <span className="relative z-10">{heroData.primaryCta}</span>
                <ArrowRight size={16} className="relative z-10 transition-transform duration-300 group-hover:translate-x-1" />
              </a>
              <span className="text-xs text-[#bcbbb4] self-center">
                {heroData.ctaSubtext}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom gradient fade to dark */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#0f1a2a] to-transparent" />
    </section>
  );
};
